import http from '../assets/jslibs/axios/http';


//获取消息
export const getUserMessage = (data) => {
  return http.get('/v1/app/UserMessage', data)
}

//获取消息详情
export const getMessageDetail = (data) => {
  return http.get(`/v1/app/UserMessage/${data}`)
}

//上下班
export const getWork = () => {
  return http.get('/v1/app/Work')
}

//是否接受微信通知
export const WechatNotice = () => {
  return http.get('/v1/app/WechatNotice')
}

